import { Flex } from '@banhala/ui-kit';
import { useGridStyle } from '../../hooks/useGridStyle';
import type { ReactNode } from 'react';

export const RectangleFilterItemBox = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { GAP } = useGridStyle();

  return (
    <Flex.Row flexWrap="wrap" gap={GAP}>
      {children}
    </Flex.Row>
  );
};
